<section class="eds-white form-wid" *ngIf="viewType=='read'"> 
  <div class="top-header spaceBtwn">
    <div class="item-middle flexStart">
      <img [src]="fixLogoUrl(this.data?.logo?.url) || 'assets/images/upload_image.png'"  class="img-circle img-responsive" alt='.'>
      <div class="logo-title " [ngClass]="textDir=='ltr'?'marL15':'marR15'">
          <div class="title t-hgt30">{{this.data?.name}}</div> 
          <div class="labeltxt marT5 fontWtg300"><i class="icon icon-position "></i>{{this.data?.country?.name}} &nbsp;&nbsp;&nbsp;&nbsp;  <i class="icon icon-alarm-level6 eds-txt-green" *ngIf="this.data?.active;"></i> <i class="icon icon-alarm-level6 eds-grey-text" *ngIf="!this.data?.active;"></i> <ng-container class="fontWtg300" *ngIf="this.data?.active; then active; else archived"></ng-container>
           
          <ng-template #active>
           {{'Active' | translate }}
         </ng-template>
    
          <ng-template #archived>
            {{'Archived' | translate }}
          </ng-template>
          </div>
      </div>
    </div>
    <div class="spaceBtwn" *ngIf="viewType=='read'">
      <div class="marT8">
        <label *ngIf="data?.active === true" class="labeltxt disabled padT5">{{'Archived' | translate }}</label>
        <label *ngIf="data?.active !== true" class="labeltxt padT5">{{'Archived' | translate }}</label> 
      </div>
      <div class="" [ngClass]="textDir=='ltr'?'padL10':'padR10'">
          <label class="switch">
              <input type="checkbox" id="usrStatus" #usrstatus [checked]="data?.active === true" (change)="confirmEnableDisable($event.target.checked)">
              <i class="ball"></i>
              <span data-enabled="Active" data-disabled="Archived" style="display: none;"></span>
          </label>
      </div>
      <div class="marT8"> 
          <label *ngIf="data?.active !== true" class="labeltxt disabled padT5" [ngClass]="textDir=='ltr'?'padL10':'padR10'">{{'Active' | translate }}</label>
          <label *ngIf="data?.active === true" class="labeltxt padT5" [ngClass]="textDir=='ltr'?'padL10':'padR10'">{{'Active' | translate }}</label>
      </div>
    </div>
  </div>

  
  <div class="switch-mob padL5">
    <label class="switch">
      <input type="checkbox" [checked]="data?.active == true" (change)="confirmEnableDisable($event.target.checked)">
      <i class="ball"></i>
      <span data-enabled="Active" data-disabled="Archived" ></span>
    </label>
  </div>
    <div class="form-sec">
    <!-- <div class="sm-12 item-middle">
      <img [src]="fixLogoUrl(this.data?.logo?.url) || 'assets/images/upload_image.png'" style="color: #9b9b9b; float: left;width: 87px;height: 87px; margin-left: 15px;margin-top: 12px;margin-bottom: 12px;" class="img-circle img-responsive" alt='.'>
      <div style="clear:both; padding-left: 10px;">
          <div class="head-one">{{this.data?.name}}</div>
          <div class="head-two">{{this.data?.country?.name}}</div>
      </div>
    </div> -->
    
    <div class="clearfix"></div>
      <div [ngClass]="viewType=='read'? 'eds-white pad20': ''" >
        <div class="sm-12 marT20 marT15 flexStart">
          <div class="labelwid"> <label class="label-light left">{{'Project name' | translate }}</label></div>
          <div class="txtW">
            <label>{{this.data?.name}}</label>
          </div>
          <!-- <div *ngIf="edited" class="labelwid">
              <a (click)="edit()" class="edit">
                  <i class="glyphicon glyphicon-pencil"></i>
                  &nbsp;&nbsp;Edit Details
              </a>
          </div> -->
        </div>
        <div class="clearfix"></div>
        <div class="sm-12 marT15 flexStart">
          <div class="labelwid"> <label class="left sm-3 label-light">{{'Description' | translate }}</label></div>
            <div class="txtW">
              <label>{{this.data?.description}}</label>
            </div>
        </div>
        <div class="clearfix"></div>
        <div class="sm-12 marT15 flexStart">
          <div class="labelwid"><label class="label-light left">{{'Country' | translate }}</label></div>
            <div class="txtW">
              <label>{{this.data?.country?.name}}</label>
            </div>
        </div>
        <div class="clearfix"></div>
        <div class="sm-12 marT15 flexStart">
          <div class="labelwid"> <label class="left label-light">{{'Lead partner' | translate }}</label></div>
            <div class="txtW">
              <label>{{this.myLeadPartner?.partner?.name}}</label>
            </div>
        </div>
        <div class="clearfix"></div>
        <div class="sm-12 marT15 flexStart">
          <div class="labelwid"><label class="sm-3 left label-light">{{'Lead pr. admin' | translate }}</label></div>
            <div class="txtW" >
                <label>{{this.myLeadAdmin?.admin?.first_name|ucfirst}} {{this.myLeadAdmin?.admin?.last_name|ucfirst}}</label>
            </div>
        </div>
      <!--   <div class="sm-12 marT15 marB20" >
         <div class="sm-11">
           <label class="left fine_text">
              * The Lead Project Administrator can assign and edit Project Administrators and Content Providers
           </label>
           </div>
        </div> -->
      </div>
    </div>
  </section>




  <section [ngClass]="viewType!='add'? 'grey-SM':'grey-M'" *ngIf="viewType=='add' || viewType=='edit'">
    
    <div [formGroup]=myFormGroup >

      <div class="top-header spaceBtwn" *ngIf="viewType=='edit'">
        <div class="item-middle flexStart">
          <!-- <img [src]="fixLogoUrl(this.data?.logo?.url) || 'assets/images/upload_image.png'" class="img-circle img-responsive" alt='.'> -->
          <app-ctl-logo-upload
            image=true
            bucket="project"
            type="logo"
            wrapperClass="ctlInputFile"
            imgClass="round"
            [imgSource]="fixLogoUrl(this.myFormGroup.get('logo').value?.url)"
            [myForm]="myFormGroup"
            (change)="formDataChanged()"
            >
          </app-ctl-logo-upload>
          <div class="logo-title " [ngClass]="textDir=='ltr'?'marL15':'marR15'">
            <div class="title t-hgt30">{{this.data?.name}}</div>
            <div class="">
              <div *ngIf="viewType=='edit' && (this.data?.logo?.url || this.myFormGroup.get('logo').value?.url)">
                  <a href="javascript:void(0);" class="removePhoto" (click)="removePhoto();">{{'Remove image' | translate}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-elem" [ngClass]="textDir=='rtl'? '':''">
      <div [ngClass]="viewType=='add'? 'pad30':'pad20'" [dir]="textDir">
     
      <div class="form-group sm-12 flexStart padB10"  *ngIf="viewType=='add'">
        <label class="title">{{'New project details' | translate }}</label>
      </div>
     
      <div class="clearfix"></div>
      <div class="eds-white" [ngClass]="viewType=='edit'?'whiteHgt':''">
        <div class="form-group row flexStart" [ngClass]="viewType=='add'?'marT10':''">
          <div class="labelwid column lg-2 md-6 sm-12"><label [ngClass]="textDir=='ltr'?'left':''">{{'Project name' | translate }}</label></div>          
          <div class="column lg-6 md-6 sm-12">
            <input id="projectName "
              type="text"
              class="form-control" [ngClass]="viewType=='edit'?'txtWEdit':'txtW'"
              placeholder="{{'Enter project name (max. 35 characters)' | translate }}"
              formControlName="name" (change)="formDataChanged()" maxlength="35" [dir]="textDir"/>
            <div *ngIf="this.myFormGroup.get('name').invalid &&
              (this.myFormGroup.get('name').dirty ||
              this.myFormGroup.get('name').touched)"
              class="alert alert-danger" [dir]="textDir">
              <div *ngIf="this.myFormGroup.get('name').errors &&
                  this.myFormGroup.get('name').errors.required">
                  {{'Name is required.' | translate }}
              </div>
              <div *ngIf="this.myFormGroup.get('name').errors &&
                  this.myFormGroup.get('name').errors.maxlength">
                  {{'Name must be less then 30 characters long.' | translate }}
              </div>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="form-group row flexStart" [ngClass]="viewType=='edit'?'marT10':'marT15'">
          <div class="labelwid column lg-2 md-6 sm-12"><label [ngClass]="textDir=='ltr'?'left':''">{{'Description' | translate}}</label></div>
            
            <div class="column lg-6 md-6 sm-12">
              <textarea class="form-control" [ngClass]="viewType=='edit'?'txtWEdit':'txtW'"
                placeholder="{{'Enter project description (max. 250 characters)' | translate }}"
                formControlName="description"
                maxlength="250 "
                cols="5" rows="5"
                (change)="formDataChanged()" [dir]="textDir"></textarea>
              <div *ngIf="this.myFormGroup.get('description').invalid &&
                  this.myFormGroup.get('description').value"
                  class="alert alert-danger" [dir]="textDir">
                  <div *ngIf="this.myFormGroup.get('description').errors &&
                      this.myFormGroup.get('description').errors.maxlength">
                      {{'Description must be less then 250 characters long.' | translate }}
                  </div>
              </div>
            </div>
        </div>
        <div class="clearfix"></div>
      <div class="form-group row flexStart" *ngIf="viewType=='edit'" [ngClass]="viewType=='edit'?'marT10':'marT15'">
        <div class="labelwid column lg-2 md-6 sm-12"> <label [ngClass]="textDir=='ltr'?'left':''">{{'Country' | translate}}</label></div>
            <div [ngClass]="viewType=='edit'?'txtWEdit textDir':'txtW textDir'" [dir]="textDir">
              <div [ngClass]="textDir">
                <ngx-select-dropdown class="ngx-dropup"  [multiple]="false" formControlName="country" [options]="myCountryList" [config]="countrySelectConfig" (change)="formDataChanged()"></ngx-select-dropdown>
              </div>
              </div>
        </div>
        <div class="clearfix"></div>
        <div class="form-group row flexStart" *ngIf="viewType=='add' || viewType=='edit'" [ngClass]="viewType=='edit'?'marT10':'marT15'">
          <div class="labelwid column lg-2 md-6 sm-12"><label [ngClass]="textDir=='ltr'?'left':''">{{'Lead partner' | translate }}</label></div>
            <div [ngClass]="viewType=='edit'?'txtWEdit textDir':'txtW textDir'" *ngIf="viewType=='edit'" [dir]="textDir">
              <div [ngClass]="textDir">
                <ngx-select-dropdown class="ngx-dropup" [multiple]="false" formControlName="lpartner" [options]="myPartnerListWithoutType | unique:'name'" [config]="partnerSelectConfig" (change)="formDataChanged()"></ngx-select-dropdown>
              </div>
              </div>
            <div *ngIf="viewType=='add'"  [ngClass]="viewType=='add'?'txtW':'txtWEdit'" [dir]="textDir">
                <ngx-select-dropdown [multiple]="false" formControlName="lpartner" [options]="myPartnerList" [config]="partnerSelectConfig"></ngx-select-dropdown>
          </div>
          <div class="marT3 " *ngIf="viewType=='add'"  [ngClass]="textDir=='ltr'?'add-new-btn':'marR10'">
            <button class="btn btn-back "  (click)="openPartnerModal()">
              {{'Add new subject' | translate}}
            </button>
          </div>
        </div>
        <div class="clearfix"></div>
        
        <div class="form-group row flexStart" *ngIf="viewType=='add'" [ngClass]="viewType=='add'?'marT15':'marT10'">
          <div class="labelwid column lg-2 md-6 sm-12"> <label [ngClass]="textDir=='ltr'?'left':''">{{'Country' | translate}}</label></div>
            <div class="txtW" [ngClass]="textDir" [dir]="textDir">
                <ngx-select-dropdown [multiple]="false" formControlName="country" [options]="myCountryList" [config]="countrySelectConfig"></ngx-select-dropdown>
            </div>
        </div>
      
        <div  class="row marT15 form-group item-middle" *ngIf="viewType=='add'">
        <div >
         <!--  <label class="grey_text" for="Project Logo">
            Logo (optional)
          </label> -->
          <div class="labelwid"> <label class="" [ngClass]="textDir=='ltr'?'left':''">{{'Logo (optional)' | translate}}</label></div>
        </div>
        <div class="padL10"  [ngClass]="textDir=='ltr'?'marL20':'marR20'">
          <app-ctl-logo-upload
            image=true
            bucket="project"
            type="logo"
            wrapperClass="ctlInputFile"
            imgClass="round"
            [imgSource]="fixLogoUrl(this.myFormGroup.get('logo').value?.url)"
            [myForm]="myFormGroup"
            (change)="formDataChanged()"
            >
          </app-ctl-logo-upload>
        </div>
        <!-- <div style="display: flex;" *ngIf="viewType=='edit' && (this.data?.logo?.url || this.myFormGroup.get('logo').value?.url)">
            <a href="javascript:void(0);" style="margin-left: 25px;" (click)="removePhoto();">Remove photo</a>
        </div> -->
      </div>


       
        <div class="form-group row flexStart" *ngIf="viewType=='edit'" [ngClass]="viewType=='edit'?'marT10':'marT15'">
          <div class="labelwid column lg-2 md-6 sm-12" style="max-width: 16.667%;line-height: 12px;"><label [ngClass]="textDir=='ltr'?'left':''">{{'Lead pr. admin' | translate}}</label></div>
           <div [ngClass]="viewType=='edit'?'txtWEd':'txtW'" [dir]="textDir">
             <div [ngClass]="textDir">
              <ngx-select-dropdown class="ngx-dropup" [multiple]="false" formControlName="ladmin" [options]="myAdminListWithoutType|unique:'name'" [config]="myAdminSelectConfig" (change)="formDataChanged()"></ngx-select-dropdown>
            </div>
          </div>
        </div>
        <div class="h-line marT20" *ngIf="viewType=='add'"></div>
        <ng-container *ngIf="viewType=='add'">
          <div class="sm-12 marT20 marB20">
            <div> <label class="left font14">{{'Lead project admin details' | translate}}</label></div>

          </div>
          <div class="clearfix"></div>
          <div class="form-group row marT15 flexStart" formGroupName="admin">
              <div class="labelwid column lg-2 md-6 sm-12"><label [ngClass]="textDir=='ltr'?'left':''">{{'First names' | translate}}</label></div>
              <div class="column lg-6 md-6 sm-12">
                <input id="firstName "
                  type="text"
                  class="form-control txtW"
                  placeholder="{{'Enter first name(s)' | translate}}"
                  formControlName="first_name" (change)="formDataChanged()" (keypress)="avoidWhiteSpace($event,'admin.first_name')" [dir]="textDir"/>
                <div *ngIf="this.myFormGroup.get('admin.first_name').invalid &&
                    (this.myFormGroup.get('admin.first_name').dirty ||
                    this.myFormGroup.get('admin.first_name').touched)"
                    class="alert alert-danger" [dir]="textDir">
                    <div *ngIf="this.myFormGroup.get('admin.first_name').errors &&
                        this.myFormGroup.get('admin.first_name').errors.required">
                        {{'First Name is required.' | translate}}
                    </div>
                    <div *ngIf="this.myFormGroup.get('admin.first_name').errors &&
                        this.myFormGroup.get('admin.first_name').errors.maxlength">
                        {{'First Name must be less then 30 characters long.' | translate}}
                    </div>
                </div>
              </div>
          </div>
          <div class="clearfix"></div>
          <div class="form-group row flexStart marT15" formGroupName="admin">
            <div class="labelwid column lg-2 md-6 sm-12"><label [ngClass]="textDir=='ltr'?'left':''">{{'Surname' | translate}}</label></div>
              <div class="column lg-6 md-6 sm-12">
                <input id="lastName"
                  type="text"
                  class="form-control txtW"
                  placeholder="{{'Enter surname' | translate}}"
                  formControlName="last_name"
                  (input)="formDataChanged()" (keypress)="avoidWhiteSpace($event,'admin.last_name')" [dir]="textDir"/>
                <div *ngIf="this.myFormGroup.get('admin.last_name').invalid &&
                    this.myFormGroup.get('admin.last_name').value"
                    class="alert alert-danger" [dir]="textDir">
                    <div *ngIf="this.myFormGroup.get('admin.last_name').errors &&
                        this.myFormGroup.get('admin.last_name').errors.maxlength">
                        {{'Last name must be less then 30 characters long.' | translate}}
                    </div>
                </div>
              </div>
          </div>
          <div class="clearfix"></div>
          <div class="form-group row flexStart marT15" formGroupName="admin">
            <div class="labelwid column lg-2 md-6 sm-12">
              
              <label class="" [ngClass]="textDir=='ltr'?'left':'rtlLabel'">{{'Email address' | translate}}</label></div> 

              <div class="column lg-6 md-6 sm-12">
                <input type="text"
                class="form-control txtW"
                id="emailAddress "
                placeholder="{{'Enter email address' | translate}}"
                formControlName="email"
                (input)="formDataChanged()" [dir]="textDir"/>
                <div *ngIf="this.myFormGroup.get('admin.email').invalid &&
                    this.myFormGroup.get('admin.email').value"
                    class="alert alert-danger" [dir]="textDir">
                    <div *ngIf="this.myFormGroup.get('admin.email').errors &&
                        this.myFormGroup.get('admin.email').errors.pattern">
                        {{'Admin email address is not valid.' | translate}}
                    </div>
                </div>
              </div>
          </div>
        </ng-container>
        <ng-container *ngIf="viewType!=='add'">
          <div class="sm-12">  
           <!--  <div class="sm-8" >
              <label class="grey_text fine_text" >
                  * The Lead Project Administrator can assign and edit Project Administrators and Content Providers
              </label>
            </div> -->
          </div>
        </ng-container>
      </div>
      </div>
    </div>

    </div>

  </section>
  
